define('MultiAddToCart.Confirmation.View', [
    'multi_add_to_cart_confirmation.tpl',

    'Backbone',
    'underscore'
], function (
    multi_add_to_cart_confirmation_tpl,

    Backbone,
    _
) {
    'use strict';

    return Backbone.View.extend({
        template: multi_add_to_cart_confirmation_tpl,

        initialize: function initialize(options) {
            this.title = _('$(0) items were added successfully').translate(
                options.itemCount
            );
        }
    });
});
